import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import { SchoolInvite } from '../entities/SchoolInvite'

@InputType()
export class InviteTeachersToSchoolArgs extends ActionArgs {
  @Field(() => ID)
  schoolId: string

  @Field(() => [ID])
  inviteeIds: string[]
}

@ObjectType()
@InputType('SchoolInviteTokenResultInput')
export class SchoolInviteTokenResult {
  @Field(() => SchoolInvite)
  invite: SchoolInvite

  /**
   * The raw invite token — the credential the emailed link carries. Deliberately NOT
   * `@Field`-decorated: the raw token must exist only in the emailed URL, never in
   * a GraphQL response, so it stays a plain TS property TypeGraphQL never serializes. Consumed
   * in-process by the invite-email sender, never returned to a client.
   */
  token: string
}

/**
 * One invitee `InviteTeachersToSchool` could not mint or send a token for — the bulk mutation
 * isolates per-invitee failures (`backend-action-style-guide.md` §3 "Partial-Failure Isolation
 * in Phase 2") rather than letting one invitee's failure abort the whole batch after earlier
 * rows are already written and their emails already sent.
 */
@ObjectType()
@InputType('InviteTeacherFailureInput')
export class InviteTeacherFailure {
  @Field(() => ID)
  inviteeId: string

  @Field(() => String)
  errorMessage: string
}

@ObjectType()
@InputType('InviteTeachersToSchoolResultInput')
export class InviteTeachersToSchoolResult {
  @Field(() => [SchoolInviteTokenResult])
  invites: SchoolInviteTokenResult[]

  @Field(() => [InviteTeacherFailure])
  failures: InviteTeacherFailure[]
}

export interface IInviteTeachersToSchool extends IAction<InviteTeachersToSchoolResult, InviteTeachersToSchoolArgs> {}
